import classNames from 'classnames';
import type { CSSProperties } from 'react';

import { css } from '@sorare/css';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconDiscord } from '#src/atoms/icons/system/iconDiscord.ts';
import { iconFacebook } from '#src/atoms/icons/system/iconFacebook.ts';
import { iconInstagram } from '#src/atoms/icons/system/iconInstagram.ts';
import { iconReddit } from '#src/atoms/icons/system/iconReddit.ts';
import { iconTiktok } from '#src/atoms/icons/system/iconTiktok.ts';
import { iconTwitter } from '#src/atoms/icons/system/iconTwitter.ts';
import { iconYoutube } from '#src/atoms/icons/system/iconYoutube.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import {
  DISCORD_INVITATION_URL,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  REDDIT_URL,
  TIKTOK_URL,
  TWITTER_URL,
  YOUTUBE_URL,
} from '#src/constants/externalLinks.ts';

const SOCIALS = [
  {
    icon: <FontAwesomeIcon icon={iconTwitter} />,
    hoverColor: 'var(--c-nd-150)',
    href: TWITTER_URL,
  },
  {
    icon: <FontAwesomeIcon icon={iconFacebook} />,
    hoverColor: 'var(--c-social-facebook)',
    href: FACEBOOK_URL,
  },
  {
    icon: <FontAwesomeIcon icon={iconInstagram} />,
    hoverColor: 'var(--c-social-instagram)',
    href: INSTAGRAM_URL,
  },
  {
    icon: <FontAwesomeIcon icon={iconDiscord} />,
    hoverColor: 'var(--c-social-discord)',
    href: DISCORD_INVITATION_URL,
  },
  {
    icon: <FontAwesomeIcon icon={iconReddit} />,
    hoverColor: 'var(--c-social-reddit)',
    href: REDDIT_URL,
  },
  {
    icon: <FontAwesomeIcon icon={iconYoutube} />,
    hoverColor: 'var(--c-social-youtube)',
    href: YOUTUBE_URL,
  },
  {
    icon: <FontAwesomeIcon icon={iconTiktok} />,
    hoverColor: 'var(--c-social-tiktok)',
    href: TIKTOK_URL,
  },
];

const root = css`
  width: 100%;
  padding: var(--unit);

  & > * {
    flex: 1;
  }
`;

const externalLink = css`
  color: var(--c-onBase-secondary);
  &:hover {
    color: var(--hover-color);
  }
  transition: 300ms color ease-in-out;
`;

export const Socials = () => {
  return (
    <Horizontal className={root} center>
      {SOCIALS.map(({ icon, href, hoverColor }) => (
        <a
          key={href}
          href={href}
          target="_blank"
          rel="noreferrer"
          style={{ '--hover-color': hoverColor } as CSSProperties}
          className={classNames(externalLink, 'text-center')}
        >
          {icon}
        </a>
      ))}
    </Horizontal>
  );
};
